import { TrackJS } from 'trackjs';

export { provideRmaTrackJs } from './lib/track-js.provide';

export function installTrackJS(application: string) {
  // token is hard coded here so it runs before application to detect all errors (if we wait for config, we won't detect start up errors)
  TrackJS.install({
    token: 'fe333a2347394ce5971a015b0855ea80',
    application,
  });
}
